var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from 'react-redux-form';
import { connect } from 'react-redux';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import { checkErrorsOnLabel } from "../utils/checkErrorsOnLabel";

import PropertyConfigOptions from "./PropertyConfigOptions";

export class FormConfigInput extends Component {
  render() {
    const { index, labelHasError, type, canBeFilter } = this.props;

    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: `form-group${labelHasError ? ' has-error' : ''}` }, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Name")), /*#__PURE__*/

      _jsx(Field, { model: `template.data.properties[${index}].label` }, void 0, /*#__PURE__*/
      _jsx("input", { className: "form-control" }))),


      type === 'geolocation' && /*#__PURE__*/
      _jsx("div", { className: "geolocation-grouping-alert" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "info-circle" }), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Adjacent geolocation properties will render on the same map"), ".")), /*#__PURE__*/



      _jsx(PropertyConfigOptions, { index: index, type: type, canBeFilter: canBeFilter })));


  }
}

FormConfigInput.defaultProps = {
  canBeFilter: true,
  labelHasError: false
};








export function mapStateToProps(state, props) {
  return {
    labelHasError: checkErrorsOnLabel(state, props)
  };
}

export default connect(mapStateToProps)(FormConfigInput);